import React, { FC, useState } from 'react';
import icons from 'style';
import { CardImage } from 'style/styled-components/reusable.css';
import { StyledSVGInline } from 'components/Epg/EpgModule/EpgModule.css';
import { ARROW_ANCHOR } from 'components/Lane/Lane.css';
import { ChannelFallbackTitle, ChannelIcon, ChannelImageWrapper, ChannelNumber } from 'components/Cards/Card/parts/CardChannelContent.css';

type PropTypes = {
    number: number;
    title: string;
    image: string;
    subscription?: boolean;
    favorite?: boolean;
    favoriteIcon: string;
    withArrowAnchor?: boolean;
    testIds?: {
        number?: string;
        icon?: string;
        lockIcon?: string;
    };
};

export const CardChannelContent: FC<PropTypes> = ({
    number,
    title,
    image,
    subscription,
    favorite,
    favoriteIcon,
    withArrowAnchor = false,
    testIds,
}) => {
    const [showFallbackTitle, setShowFallbackTitle] = useState(false);

    return (
        <>
            <ChannelNumber data-test-id={testIds?.number}>{number}</ChannelNumber>
            <ChannelIcon data-test-id={testIds?.icon}>
                {(!subscription && <StyledSVGInline data-test-id={testIds?.lockIcon} svg={icons.lockIcon} />) ||
                    (favorite && <StyledSVGInline svg={favoriteIcon} />)}
            </ChannelIcon>
            {showFallbackTitle && <ChannelFallbackTitle>{title}</ChannelFallbackTitle>}
            {!showFallbackTitle && (
                <ChannelImageWrapper {...(withArrowAnchor ? { [ARROW_ANCHOR]: '' } : {})}>
                    <CardImage
                        url={image}
                        alt={title}
                        {...{
                            imageError: () => {
                                setShowFallbackTitle(true);
                            },
                        }}
                    />
                </ChannelImageWrapper>
            )}
        </>
    );
};
